import { render } from "./CategoriesList.vue?vue&type=template&id=1b4cfbe3&ts=true"
import script from "./CategoriesList.vue?vue&type=script&lang=ts"
export * from "./CategoriesList.vue?vue&type=script&lang=ts"

import "./CategoriesList.vue?vue&type=style&index=0&id=1b4cfbe3&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__